export const userBaseUrl = process.env.REACT_APP_API_BASE_URL + "/api";
export const devBaseUrl = process.env.REACT_APP_API_BASE_URL + "/dev";
export const loginBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const goBaseUrl =
	process.env.REACT_APP_GO_BASE_URL_DEV ||
	process.env.REACT_APP_GO_BASE_URL ||
	"http://localhost:8080";
export const LOCAL = process.env.REACT_APP_GO_BASE_URL || "http://localhost:8080";
export const LOCAL8081 = "http://localhost:8081";
